/* 자산등록 페이지에서 등록 가능한 자산 유형값  */
// export const onAssetTypeSelectOptions = [
//     { text: 'centos(리눅스 서버)', value: 'centos'},
//     { text: 'redhat(리눅스 서버)', value: 'redhat'},
//     { text: 'linux(리눅스 서버)', value: 'linux'},
//     { text: 'ubuntu(리눅스 서버)', value: 'ubuntu'},
//     { text: 'freebsd(리눅스 서버)', value: 'freebsd'},
//     { text: 'aix(리눅스 서버)', value: 'aix'},
//     { text: 'hp-ux(리눅스 서버)', value: 'hp-ux'},
//     { text: 'solaris(리눅스 서버)', value: 'solaris'},
//     { text: 'sunos(리눅스 서버)', value: 'sunos'},
//     { text: 'tru64(리눅스 서버)', value: 'tru64'},
//     { text: 'stratus(리눅스 서버)', value: 'stratus'},
//     { text: 'tandem(리눅스 서버)', value: 'tandem'},
//     { text: 'windows(윈도우 서버)', value: 'windows'},
//     { text: 'oracle(DBMS)', value: 'oracle'},
//     { text: 'mysql(DBMS)', value: 'mysql'},
//     { text: 'mariadb(DBMS)', value: 'mariadb'},
//     { text: 'postgresql(DBMS)', value: 'postgresql'},
//     { text: 'mssql(DBMS)', value: 'mssql'},
//     { text: 'nginx(WEB)', value: 'nginx'},
//     { text: 'apache(WEB)', value: 'apache'},
//     { text: 'resin(WEB)', value: 'resin'},
//     { text: 'tomcat(WEB)', value: 'tomcat'},
//     { text: 'webtob(WEB)', value: 'webtob'},
//     { text: 'jeus(WEB)', value: 'jeus'},
//     { text: 'jboss(WEB)', value: 'jboss'},
//     { text: 'jrun(WEB)', value: 'jrun'},
//     { text: 'weblogic(WEB)', value: 'weblogic'},
//     { text: 'websphere(WEB)', value: 'websphere'},
//     { text: 'iplanet(WEB)', value: 'iplanet'},
//     { text: 'iis(WEB)', value: 'iis'},
//     { text: 'firewall(정보보호시스템(FW))', value: 'firewall'},
//     { text: 'vpn(정보보호시스템(VPN))', value: 'vpn'},
//     { text: 'wireless(무선 네트워크)', value: 'wireless'},
//     { text: 'network(네트워크 장비)', value: 'network'},
//     { text: 'android(모바일 앱)', value: 'android'},
//     { text: 'ios(모바일 앱)', value: 'ios'},
//     { text: 'WindowPc(PC(Windows))', value: 'WindowPc'},
//     { text: 'MacPc(PC(Mac))', value: 'MacPc'},
//     { text: 'www(URL)', value: 'www'},
//     { text: 'webadmin(URL)', value: 'webadmin'},
//     { text: 'ddos(정보보호시스템(DDOS))', value: 'ddos'},
//     { text: '문서(문서)', value: '문서'},
//     { text: 'fileserver(파일서버)', value: 'fileserver'},
//     { text: 'printer(물리적 자산)', value: 'printer'},
//     { text: 'esp(Software)', value: 'esp'},
//     { text: 'kt cloud(클라우드)', value: 'kt cloud'},
//     { text: 'naver cloud(클라우드)', value: 'naver cloud'},
//     { text: 'nhn cloud(클라우드)', value: 'nhn cloud'},
// ];

/* DB에 저장된 코드는 CodeSelect 에서 직접 조회 */
/* 자산 : 사용여부 체크  */
export const ynSelectOptions = [
    { text: 'Y', value: 'Y' },
    { text: 'N', value: 'N' },
];


/* 진단결과 옵션  */
export const analySelectOptions = [
    { text: '전체', value: '' },
    { text: 'Y', value: 'Y' },
    { text: 'N', value: 'N' },
    { text: '확인필요', value: 'SELF' },
    { text: '부분진단', value: 'P' },
    { text: '해당사항 없음', value: 'NA' },
];

/* 진단스크립트가 실행될 OS type: os 유형  */
export const osSelectOptions = [
    { text: '-', value: '-' },
    { text: 'Linux', value: 'Linux' },
    { text: 'Unix', value: 'Unix' },
    { text: 'Windows', value: 'Windows' },
];

/* 자산관리 : 스코어 */
export const scoreSelectOptions = [
    { text: '1', value: '1' },
    { text: '2', value: '2' },
    { text: '3', value: '3' },
];

/* 위협 : 등급 */
export const gradeSelectOptions = [
    { text: 'H', value: 'H' },
    { text: 'M', value: 'M' },
    { text: 'L', value: 'L' },
];

/* 진단결과유형 */
export const resultTypeSelectOptions = [
    { text: '최초분석', value: 'C' },
    { text: '이행점검', value: 'U' },
];

/* 진단결과여부 */
export const resultCdSelectOptions = [
    { text: '양호', value: 'Y' },
    { text: '부분이행', value: 'P' },
    { text: '취약', value: 'N' },
    { text: 'N/A', value: 'NA' },
    { text: 'SELF', value: 'SELF' },
];

/* 위험관리 : 대응전략 */
export const applyActionSelectOptions = [
    { text: '', value: '' },
    { text: '위험감소', value: '위험감소' },
    { text: '위험수용', value: '위험수용' },
    { text: '위험이전', value: '위험이전' },
    { text: '위험회피', value: '위험회피' },
];


/* 위험관리 : 적용시기 */
export const applyTimeSelectOptions = [
    { text: '단기', value: '단기' },
    { text: '중기', value: '중기' },
    { text: '장기', value: '장기' },
];

/* 위험관리 : 적용시기별 조치일정 설정 (일 단위) */
export const applyTimeDays = {
    '단기': 90, 
    '중기': 181,
    '장기': 366 
};

/* 위험관리 : 적용시기별 검증 범위 (일 단위) */
export const applyTimeRanges = {
    '단기': { min: 0, max: 90 },      // 0~90일 (3개월 이내)
    '중기': { min: 91, max: 365 },    // 91~365일 (3개월 초과 ~ 1년 이내)
    '장기': { min: 365, max: 3650 }     // 181~365일 (6개월 초과 ~ 1년 이내)
};

/* 로그관리 : 로그구분 */
export const logTypeSelectOptions = [
    { text: '', value: '' },
    { text: '사용자_로그인', value: '/login/' },     //logType지정
    { text: '사용자_로그아웃', value: '/logout/' },  //logType지정
    { text: '사용자_비밀번호변경', value: '/accounts/change_password/' },
    { text: '자산_등록/수정/삭제', value: '/edit/Asset/' },
    { text: '자산_일괄업로드', value: '/create/AssetUpload/' },
    { text: '보고서_생성', value: '/create/AnalysisReport/' },
    { text: '보고서_일괄삭제', value: '/edit/ReportAllDelete/' },
    { text: '보고서_정보수정', value: '/edit/ReportInfoEdit/' },
    { text: '보고서_자산수정', value: '/edit/VaAsset/' },
    { text: '보고서_진단항목수정', value: '/edit/VaMeasure/' },
    { text: '보고서_권고사항수정', value: '/edit/VaSuggest/' },
    { text: '보고서_위험항목수정', value: '/edit/VaThreat/' },
    { text: '보고서_기준항목업로드', value: '/create/VaBaseUpload/' },  //logType지정
    { text: '분석결과_업로드', value: '/create/ResultUpload/' },
    { text: '분석결과_결과분석', value: '/edit/ResultAnalysis/' },
    { text: '분석결과_결과수정', value: '/edit/VaResult/' },
    { text: '템플릿_생성', value: '/create/Template/' },  //logType지정
    { text: '템플릿_기준항목업로드', value: '/create/TemplateUpload/' },
    { text: '템플릿_진단항목수정', value: '/edit/TemplateMeasure/' },  //logType지정
    { text: '템플릿_권고사항수정', value: '/edit/TemplateSuggest/' },  //logType지정
    { text: '템플릿_위험항목수정', value: '/edit/TemplateThreat/' },   //logType지정
];



export const getAssetTypeValue = ()=>{
    const codeList = JSON.parse(localStorage.getItem("code_list") || []);

    const codeListSpec = codeList.filter(item => item.type === "asset_type").reduce((obj, item) => {
        obj[item.value] = [item.text, item.value, osSelectOptions[0].value];
        return obj;
    }, {});
    return codeListSpec;
}

// export const assetTypeValue = {
//     NW: ["네트워크장비", "network", osSelectOptions[0].value],
//     LX: ["리눅스 서버", "linux", osSelectOptions[1].value],
//     WN: ["무선네트워크", "wireless", osSelectOptions[0].value],
//     SE: ["부대시설", "other", osSelectOptions[0].value],
//     WS: ["윈도우 서버", "windows", osSelectOptions[3].value],
//     FW: ["정보보호시스템(FW)", "fireWall", osSelectOptions[0].value],
//     DB: ["DBMS", "mysql", osSelectOptions[1].value],
//     WW: ["URL", "web", osSelectOptions[0].value],
//     WE: ["WEB", "Apache", osSelectOptions[1].value],
//     SW: ["Software", "software", osSelectOptions[0].value],
//     PC: ["PC(Windows)", "WindowsPC", osSelectOptions[3].value],
//     PM: ["Mac", "mac", osSelectOptions[0].value],
//     DO: ["문서", "document", osSelectOptions[0].value],
//     MO: ["모바일", "mobile", osSelectOptions[0].value],
//     FS: ["파일서버", "fileserver", osSelectOptions[0].value],
//     CS: ["클라우드", "cloud", osSelectOptions[0].value],
//     DD: ["정보보호시스템(DDoS)", "DDoS", osSelectOptions[0].value],
//     VP: ["정보보호시스템(VPN)", "VPN", osSelectOptions[0].value],
//     KUM: ["Kubernetes(Master)", "Kubernetes(Master)", osSelectOptions[0].value],
//     KUW: ["Kubernetes(Worker)", "Kubernetes(Worker)", osSelectOptions[0].value],
//     AWS: ["AWS", "AWS", osSelectOptions[0].value],
//     NCP: ["Naver Cloud", "Naver Cloud", osSelectOptions[0].value],
//     GCP: ["Google Cloud Platform", "Google Cloud Platform", osSelectOptions[0].value],
//     ESX: ["ESXi", "ESXi", osSelectOptions[0].value],
//     EL:  ["Elasticsearch", "Elasticsearch", osSelectOptions[0].value],
//     IND: ["InfluxDB", "InfluxDB", osSelectOptions[0].value],
//     MOD: ["MongoDB", "MongoDB", osSelectOptions[0].value],
//     MOD: ["MongoDB", "MongoDB", osSelectOptions[0].value],
//     ANT: ["백신", "antivirus", osSelectOptions[0].value],
//     DLP: ["DLP", "DLP", osSelectOptions[0].value],
//     CLNOD: ["Node.js", "Node.js", osSelectOptions[0].value],
//     CLRDS: ["Redis", "Redis", osSelectOptions[0].value],
// };


export const chart_options_bar = {
    plugins: {
        legend: {
            display: false,
        }
    },
    scales: {
        y: {
            beginAtZero: true,
            suggestedMin: 0,
            suggestedMax: 100
        }
    },
    // barThickness: 30, 
    maintainAspectRatio: false
}

export const chart_options_bar_y = {
    indexAxis: 'y',
    plugins: {
        legend: {
            display: false,
        }
    },
    scales: {
        y: {
            beginAtZero: true
        }
    },
    maintainAspectRatio: false
}

export const chart_options_radar = {
    plugins: {
        legend: {
            display: false,
        },
        filler: {
            propagate: false
        },
    },
    maintainAspectRatio: false,
    elements: {
        line: {
            borderWidth: 1
        }
    },
    scales: {
        r: {
            angleLines: {
                display: true
            },
            suggestedMin: 0,
            suggestedMax: 100
        }
    },
}

const getOrCreateTooltip = (chart) => {
    let tooltipEl = chart.canvas.parentNode.querySelector('div');

    if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.style.background = 'rgba(0, 0, 0, 0.6)';
        tooltipEl.style.borderRadius = '6px';
        tooltipEl.style.color = 'white';
        tooltipEl.style.opacity = 1;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.transform = 'translate(-50%, 0)';
        tooltipEl.style.transition = 'all .1s ease';
        tooltipEl.style.zIndex = 999999;

        const table = document.createElement('table');
        table.style.margin = '5px';

        tooltipEl.appendChild(table);
        chart.canvas.parentNode.appendChild(tooltipEl);
    }

    return tooltipEl;
};


const externalTooltipHandler = (context) => {
    // Tooltip Element
    const { chart, tooltip } = context;
    const tooltipEl = getOrCreateTooltip(chart);

    // Hide if no tooltip
    if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
    }

    // Set Text
    if (tooltip.body) {
        const titleLines = tooltip.title || [];
        const bodyLines = tooltip.body.map(b => b.lines);

        const tableHead = document.createElement('thead');

        titleLines.forEach(title => {
            const tr = document.createElement('tr');
            const th = document.createElement('th');
            th.colSpan = 2;
            const text = document.createTextNode(title);
      
            th.appendChild(text);
            tr.appendChild(th);
            tableHead.appendChild(tr);
        });

        const tableBody = document.createElement('tbody');
        bodyLines.forEach((body, i) => {
            const colors = tooltip.labelColors[i];

            const tr = document.createElement('tr');
            tr.style.backgroundColor = 'inherit';
            tr.style.borderWith = '5px';

            const td01 = document.createElement('td');
            td01.style.paddingBlock = '2px';

            const div01 = document.createElement('div');
            div01.style.background = colors.backgroundColor;
            div01.style.borderColor = colors.borderColor;
            div01.style.borderWidth = '2px';
            div01.style.marginRight = '6px';
            div01.style.height = '16px';
            div01.style.width = '16px';
            div01.style.zIndex = 999999;

            const td02 = document.createElement('td');
            const text = document.createTextNode(body);

            td01.appendChild(div01);
            td02.appendChild(text);
            tr.appendChild(td01);
            tr.appendChild(td02);
            tableBody.appendChild(tr);
        });

        const tableRoot = tooltipEl.querySelector('table');

        // Remove old children
        while (tableRoot.firstChild) {
            tableRoot.firstChild.remove();
        }

        // Add new children
        tableRoot.appendChild(tableHead);
        tableRoot.appendChild(tableBody);
    }

    const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

    // Display, position, and set styles for font
    tooltipEl.style.opacity = 1;
    tooltipEl.style.left = positionX + tooltip.caretX + 'px';
    tooltipEl.style.top = positionY + tooltip.caretY + 'px';
    tooltipEl.style.font = tooltip.options.bodyFont.string;
    tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
};

let isDragging = false; //클릭 이벤트와 구별하기 위한 변수
let isStart = true; // 마우스 첫번째 드래그 확인 (mousedown이벤트가 없어서 변수 사용하여 기능대체)

export const chart_options_line = {
    responsive: true,
    // interaction: {      // 이 옵션객체를 삭제하면 툴팁이 라인에 있는 점에 마우스를 올려야만 표시됨
    //   mode: 'index',    // x축의 같은 인덱스에 있는 모든 데이터 포인트를 표시
    //   intersect: false // 마우스가 선 위에 있지 않아도 가장 가까운 데이터 포인트 표시
    // },
    layout: {
        padding: 15
    },
    scales: {
        x: {
            offset: true, // 차트 시작점에 여백 추가
            ticks: {
                font: {
                    size: 14  // x축 레이블 폰트 크기
                },
                // padding: 10
            }
        },
        y: {
            ticks: {
                callback: function(value){
                    return value+'%';
                },
            }
        }
    },
    plugins: {
        legend: {
            position: 'top',
            labels: {
                // This more specific font property overrides the global property
                font: {
                    size: 14
                },

            },
            onClick: (event, legendItem, legend) => {
                // 범례 클릭 이벤트
                if(!isDragging){
                    const index = legendItem.datasetIndex;
                    const chart = legend.chart;

                    if (chart.isDatasetVisible(index)) {
                        chart.hide(index);
                        legendItem.hidden = true;
                    } else {
                        chart.show(index);
                        legendItem.hidden = false;
                    }
                    chart.update();
                }
            },
            onHover: (event, legendItem, legend) => {
                if (event.native.buttons === 1) { 
                    isDragging = true;
                    const index = legendItem.datasetIndex;
                    const chart = legend.chart;

                    if (chart.isDatasetVisible(index)) {
                        chart.hide(index);
                        legendItem.hidden = true;
                    } else {
                        chart.show(index);
                        legendItem.hidden = false;
                    }
                    chart.update();
                    isStart = false;
                }else{
                    isDragging=false;
                    isStart = true;
                }
            },   
            onLeave: (event, legendItem, legend) => {
                if (event.native.buttons !== 1 && !isDragging) { 
                    isDragging = false;
                    isStart = true;
                }else{

                    if (isStart) {
                        const index = legendItem.datasetIndex;
                        const chart = legend.chart;

                        if (chart.isDatasetVisible(index)) {
                            chart.hide(index);
                            legendItem.hidden = true;
                        } else {
                            chart.show(index);
                            legendItem.hidden = false;
                        }
                        chart.update();
                        isStart = false;
                    }
                }
            }
            
        },

        title: {
            display: false,
            text: '미지정'
        },

        tooltip: {
            enabled: false,
            position: 'nearest',
            external: externalTooltipHandler
        }
    }
};

export const assetCertGroup = {
    isms: "ISMS 인증",
    iso : "ISO 인증",
    fiu : "전자금융",
    kisa : "주요정보통신 기반"
};

export const createEventSource = (apiUrl) => new EventSource(apiUrl);